import React, { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { CustomAccordion } from "../components";
import { VarianceChart, CombinedChart } from "../../charts";
import { DropdownProps } from "../types";

const VarianceDropdown = ({ searchFilters, subTypeChart, currentMainTab }: DropdownProps) => {
  const currentDate = dayjs.utc();
  const [varianceStartDate, setVarianceStartDate] = useState<Dayjs>(dayjs(currentDate.date(1)).subtract(2, "month"));
  const [varianceEndDate, setVarianceEndDate] = useState<Dayjs>(dayjs(currentDate));

  return <CustomAccordion
    titleAccordion="Variance"
    panelNumber={1}
    allowDates
    startDate={varianceStartDate}
    endDate={varianceEndDate}
    setStartDate={setVarianceStartDate}
    setEndDate={setVarianceEndDate}>
    <VarianceChart
      startDate={varianceStartDate}
      endDate={varianceEndDate}
      subTabName={subTypeChart}
      searchFilters={searchFilters}
      chartTitle="Comparing Current Period, Same Period Last Year"
      currentMainTab={currentMainTab}
    />
    <CombinedChart
      startDate={varianceStartDate}
      endDate={varianceEndDate}
      subTabName={subTypeChart}
      chartTitle="Variance Absolute and Percentage Amounts"
      searchFilters={searchFilters}
      currentMainTab={currentMainTab}
    />
  </CustomAccordion>
}

export default VarianceDropdown;